module.exports = __webpack_public_path__ + "static/media/newline6.40bedfc8.jpg";